import { useState } from "preact/hooks"
import { ChevronDown, ChevronRight, Wrench, Check, Loader2 } from "lucide-react"

interface ToolCallDisplay {
  toolName: string
  args: any
  result?: any
  confirmationRequired?: boolean
  status: "calling" | "done"
}

interface ToolCallCardProps {
  toolCall: ToolCallDisplay
  className?: string
}

export function ToolCallCard({ toolCall, className }: ToolCallCardProps) {
  const [expanded, setExpanded] = useState(false)
  const isDone = toolCall.status === "done"

  return (
    <div class={`border border-gray-200 rounded-lg overflow-hidden ${className || ""}`}>
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        class="w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-gray-50"
      >
        <div class={`flex-shrink-0 w-5 h-5 rounded flex items-center justify-center ${
          isDone ? "bg-green-100 text-green-600" : "bg-primary/10 text-primary"
        }`}>
          {isDone ? (
            <Check className="w-3 h-3" />
          ) : (
            <Loader2 className="w-3 h-3 animate-spin" />
          )}
        </div>
        <Wrench className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" />
        <span class="font-medium text-gray-700 flex-1 text-left">
          {formatToolName(toolCall.toolName)}
        </span>
        {expanded ? (
          <ChevronDown className="w-4 h-4 text-gray-400" />
        ) : (
          <ChevronRight className="w-4 h-4 text-gray-400" />
        )}
      </button>

      {expanded && (
        <div class="border-t border-gray-200 px-3 py-2 space-y-2 bg-gray-50">
          <div>
            <p class="text-xs font-medium text-gray-500 mb-1">Arguments</p>
            <pre class="text-xs text-gray-600 bg-white rounded p-2 overflow-x-auto">
              {JSON.stringify(toolCall.args, null, 2)}
            </pre>
          </div>
          {toolCall.result && (
            <div>
              <p class="text-xs font-medium text-gray-500 mb-1">Result</p>
              <pre class="text-xs text-gray-600 bg-white rounded p-2 overflow-x-auto max-h-64 overflow-y-auto">
                {JSON.stringify(toolCall.result, null, 2)}
              </pre>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

function formatToolName(name: string): string {
  return name
    .replace(/_/g, " ")
    .replace(/\b\w/g, (l: string) => l.toUpperCase())
}
